// extracted by mini-css-extract-plugin
export var brand = "_i-9";
export var button = "_i-0";
export var chevron = "_i-v";
export var chevronButton = "_i-w";
export var content = "_i-n";
export var danger = "_i-g";
export var dangerOutlined = "_i-h";
export var dark = "_i-l";
export var darkTheme = "_i-c";
export var extraSmall = "_i-4";
export var fullWidth = "_i-8";
export var ghost = "_i-d";
export var gray = "_i-t";
export var icon = "_i-p";
export var iconButton = "_i-s";
export var iconButtonBorder = "_i-x";
export var iconButtonBorderDark = "_i-y";
export var iconButtonBorderLight = "_i-z";
export var iconLeft = "_i-q";
export var iconRight = "_i-r";
export var large = "_i-1";
export var light = "_i-m";
export var medium = "_i-2";
export var micro = "_i-5";
export var nano = "_i-7";
export var outlined = "_i-k";
export var pending = "_i-a";
export var primary = "_i-i";
export var shadow = "_i-o";
export var small = "_i-3";
export var solidLight = "_i-e";
export var solidLightBrand = "_i-f";
export var spinner = "_i-u";
export var transparent = "_i-j";
export var warning = "_i-b";
export var wideNano = "_i-6";